<template>
    <div class="news-detail">
        <div class="news-detail-wrapper wrapper flex-between">
            <div class="news_detail_left">
                <div class="content-box">
                    <div class="title-box">
                        <h3 class="f18">{{$route.query.name}}</h3>
                        <!-- <p class="source f12">
                            <span> 来源：xxx</span>
                            <span> 作者：xxx </span>
                            <span> 责任编辑：xx</span>
                        </p> -->
                        <p class="other-info f12 flex-layout">
                            <span>{{article.updateTime}}</span>
                            <!-- <span class="eye">{{article.views || 0}}</span> -->
                        </p>
                    </div>
                    <div class="content">
                        <template v-if="$route.query.index == 0">
                            <p>内蒙古自治区鄂尔多斯市认真学习贯彻党的二十大精神，深入落实习近平总书记关于教育的重要论述，纵深推进教育数字化战略行动，
                                以“实现城乡教育一体化”为目标打造“新基建”下的乡村数字教育环境，通过现代信息技术促进乡村教育跨越式发展，努力推动乡村教育振兴。</p>
                            <p><span
                                    style="font-weight:bold">加强统筹谋划，兼顾一体推进和乡村优先。</span>一是建设城乡一体化教育专网。规划并建设“双万兆骨干到旗区”和“三层结构校园网到桌面”的教育城域网，
                                为全市城乡学校、幼儿园提供教育专网服务，组织专业队伍开展“网络服务质量提升”等专项入校服务，打通农村牧区学校校园网络接入通道，建成城乡一体化教育专网，
                                保障农村牧区学校与城市学校具备同样的网络与资源承载能力。二是建设城乡一体化教育云平台。为全市学校、幼儿园提供保障、基础、通用的教育云服务，
                                在国家及自治区提供的公共数字教育资源的基础上，市教育云平台另外提供9个品牌和类型的数字教育教学资源。资源获取途径覆盖网页端、移动端和有线电视端。
                                三是优先支持乡村基础建设。依托教育专网，在全市118所农村牧区学校和幼儿园建设“网际交互教室”，支持开展跨区域教研教学，让农村牧区学校学生可以使用智慧教学终端进行学习，
                                农村学校使用专业创客教室开展科创教育。</p>
                            <p><span
                                    style="font-weight:bold">加强结对共建，实现有效帮扶和互促共进。</span>一是推动“三个课堂”常态化应用。通过城乡结对、线上线下融合（OMO）以及专递服务等方式，实现“数字支教”“数字共生”，
                                城乡学校以更自由的形式组建跨区域“共同体”。优秀教研员和城市优质结对校教师共同诊断教学过程，评价教学效果，指导乡村教师优化教学行为，提升专业素质。二是乡村学校率先探索智慧教育。
                                5所乡镇学校组成智慧教育发展共同体，探索形成覆盖语文、数学、英语等3个学科的“基于高阶思维发展的211智慧课堂教学模式”，带动7个旗区、
                                22所城镇学校加入区域教学模式变革的实践。三是拓宽科创教学服务覆盖面。城乡结对开展STEAM和创客教学，推动市级、旗区级科技动漫节等活动下沉基层，使最前沿的科技教育成果惠及乡村师生。
                            </p>
                            <p><span
                                    style="font-weight:bold">加强数据服务，赋能师生发展和教育治理。</span>一是服务教师教育教学与专业发展。在教师空间聚合提供各类资源与工具，反映教师教案、课件、试题等教学资源使用数据，
                                备授课、考试组卷、作业批阅、诊断分析、教研评价等应用情况和学习、研修、实践反思、合作交流、知识共享等教师专业发展数据，帮助教师调整改进教学内容，提升教育教学能力。
                                二是服务学生日常学习与全面成长。在学生空间聚合提供数字化阅读、智慧教学、自主学习、多元评价等学生成长类应用，通过对随堂测练实时反馈、共性错题回溯、学习过程分析、作业评价
                                、行为画像等数据的积累与挖掘，不断提高学习资源适配度，实现学生自适应学习，帮助学生全面成长。三是服务学校科学管理和效率提升。在机构空间聚合提供排课、选课
                                、安全巡检、图书管理等应用，把工作指令、管理规定等转换为简便易操作的二维码和数字按键，将纸质台账转变为统计图表，让管理更加可见易控，以数字化驱动乡村学校的精细化管理，全面提升乡村学校治理水平。
                            </p>
                        </template>
                        <template v-if="$route.query.index == 1">
                            <p>2021年7月国家提出开展教育新型基础设施建设（简称“新基建”）以来，全国教育信息化驶入了快车道。
                                为避免公共基础设施保障能力更好的城市进一步拉开与农村牧区的差距，需要优先推进农村牧区教育信息化设施。内蒙古鄂尔多斯市以“实现城乡教育一体化”为目标打造“新基建”下的数字教育环境，
                                积极消除数字“鸿沟”，围绕信息网络、平台体系、数字资源、智慧校园、创新应用、可信安全等领域开展建设，让农村牧区广大师生享有更多“互联网+”红利，以现代信息技术促乡村教育跨越式发展，振兴乡村教育。
                            </p>
                            <span style="font-weight:bold">构建城乡一体化数字教学资源</span>
                            <p>建设城乡一体化的教育专网，通过教育城域网实现了对全市城乡学校、幼儿园无差别全连接。其中，教育城域网双万兆骨干（到旗区）和三层结构校园网（到桌面）让学校的千兆接入和师生高速网络连接有了保障，
                                通过组织专业队伍开展“网络服务质量提升”等专项入校服务，切实提升农村牧区学校校园网络建设与运维水平，真正令农村牧区学校的网络承载能力不输城市学校。</p>
                            <p>全市现有的118所农村牧区学校和幼儿园，与城镇以上的330所学校和幼儿园一样，全部以千兆及以上速率接入了市教育城域网，不仅与市内城镇学校处于同一起跑线，
                                甚至相较于国内一线发达地区也毫不逊色，提早实现了国家教育专网接入与网络接入带宽的要求。</p>
                            <p>市级统筹构建城乡一体化教育云平台，为全市包括农村牧区在内的所有学校、幼儿园提供保障、基础、通用的教育云服务，包括数字教育教学资源与教育教学管理应用服务。
                                在国家和自治区提供的公共数字教育资源的基础上，市教育云另外提供了9个品牌和类型的数字教育教学资源，包括超星数字图书与期刊、通识与学科在线课程、学科网资源
                                、菁优网资源、教师研训、安全教育以及电视教育等资源，从网页端、移动端到有线电视端，每所学校、每名师生、每个家庭都可选择适合自己需要的资源使用，也实现了
                                “农村牧区学校与全市条件最好的中小学使用同样的数字教学资源”。</p>
                            <p>在优质数字资源的支撑下，乡村学校率先迈出了探索“智慧课堂”的脚步，成为教育数字化转型的“先锋队”和“排头兵”：5所学校自发组成智慧教育发展共同体，探索形成覆盖语文、
                                数学、英语等3个学科的“基于高阶思维发展的211智慧课堂教学模式”，有效促动7个旗区、22所城镇学校纷纷加入区域教学模式变革的实践行列中，成为鄂尔多斯市承担的国家级“
                                融合信息技术的新型教与学模式”实验区工作的“先锋队”。</p>
                            <img src="../assets/detail/04.png" alt="">
                            <span style="font-weight:bold">数据可视化补齐乡村教育管理短板</span>
                            <p>与城镇学校相比，乡村学校管理人员的素养存在一定差距。为补齐乡村教育管理短板，市教育云还提供了安全巡检、排课、选课、网络阅卷、成绩分析、学生评价、图书管理等应用。
                                安全巡检应用助力乡村学校将安全工作落到实处，教职工主动参与校园巡检，将84%的安全风险消除在萌芽状态；排课应用将教务人员的工作量从2天缩短到2个小时，把学校的教学
                                工作安排得井井有条；选课应用帮助1/3的农村学校组织课后服务更加轻松；成千上万册纸质书刊在云服务下管理不再是难题，流通率、借阅率、馆藏结构等各项数据实时可查，
                                乡村学校图书资源配置更加均衡、更有效率……应用服务把一条条行政指令、一项项管理规定转化为简便易操作的二维码和数字按键，将纸质台账转变为统计图表，在“市－旗－校
                                ”三级教育数据可视化助力下，118所乡村学校、幼儿园教育管理效能实现全面提升。</p>
                            <span style="font-weight:bold">智慧课堂教学回归学生本位</span>
                            <p>在班级数字教学环境构建等方面，让农村牧区学校走在前面。所有农村牧区学校全部配备了80英寸以上多媒体触控一体机（早于很多城镇学校），所有农村牧区学校都能够使用国家、
                                自治区和市教育部门提供的公共数字教学资源服务，供教师日常教学使用；所有农村牧区学校全部配有支持网络远程互动教学教研的“网际交互教室”，
                                可随时跨越空间与结对帮扶学校或联盟校开展教学、教研活动；在10所农村牧区学校率先开展基于平板电脑的智慧课堂教学，做到了全校学生平板电脑的全覆盖，
                                涌现出一批市级“智慧教学名师”。在鄂尔多斯，乡村课堂不再是想象中沉闷的“照本宣科”“满堂灌”，借助智慧教学设备、平台、资源，学生不再局限在教室的一方天地，
                                而是“漫步云端”、遨游在广阔的网络学习空间，课堂教学更回归学生本位。</p>
                            <div style="display:flex;align-items:center;justify-content: space-around;margin-bottom:15px">
                                <img src="../assets/detail/05.png" alt="">
                            </div>
                            <p>在农村牧区学校常态化开展网络研训与中小学STEAM教育，让农村牧区学校师生具备数字时代的获得感。城乡结对教研共同体建设，让农村教师能够通过网络参加城市结对学校日常教研和各类研修活动，
                                城乡教师同步利用人工智能等技术提升业务能力，让农村教师同步拥有成就感和获得感，城乡结对不仅只是“单向帮扶”，而逐渐转变为“双向互促”。</p>
                            <p>近年涌现出以乌审旗的英语教师郭娜、准格尔旗纳日松镇羊市塔村的语文教师冯雅颂等为代表的一批佼佼者；农村牧区学校配备创客教室，城乡结对开展STEAM和创客教学，
                                市旗区科技动漫节等活动下沉基层服务等举措，使最前沿的科技教育成果同样惠及乡村师生，让农村牧区的学生感受到农村教育同样生机勃发，从而更愿意就近就学。
                                伊金霍洛旗高级中学杨峻岳老师每周在新街中学（伊金霍洛旗第二中学）为学生讲授创客课程，全校近1/6的学生选修，2021年所带学生参加全市人工智能挑战赛获一、二等奖三项。</p>
                            <div style="display:flex;align-items:center;justify-content: space-around;margin-bottom:15px">
                                <img src="../assets/detail/06.png" alt="">
                            </div>
                            <span style="font-weight:bold;display:block">城乡教学结对发展</span>
                            <p>信息化为乡村学校协同发展提供了机遇。在地域分布上较为分散的乡村学校往往会陷入“孤岛效应”，在网际交互教室的支持下，乡村学校能够与市域内任何一所其他学校“同频互动”，
                                以更自由的形式组建“共同体”。“三个课堂”、城乡结对、OMO（线上+线下）融合以及专递服务等方式推动实现了数字支教，把优质教育教学资源与教育服务常态化送到农村牧区学校。
                                教学方面，通过“三个课堂”（专递课堂、名师课堂、名校网络课堂），让农村牧区学校的师生同步获得高质量的教学内容，通过教研员和城市优质结对校教师指导优化教学行为，诊断教学过程，评价教学效果，让乡村学校教学不断进步，常态化进步。
                            </p>
                            <p>康巴什区第三小学和杭锦旗吉日嘎郎图小学2019年起通过OMO模式开展结对共建教学共同体，2021年吉乡小学在多项教学指标上优于城市学校，成为城乡结对发展的典范。
                                农村牧区学校在教学之外的日常运维等方面同样需要支持，以网络与信息安全运维为例，市旗两级统筹，成立专门团队集中力量“专递”网络信息、安全检测、
                                漏洞扫描等服务到农村牧区学校，解决他们技术力量薄弱等问题，确保各类信息化设施使用流畅、安全可信，为基于数字化的城乡教育一体化提供了保障。</p>
                        </template>
                        <template v-if="$route.query.index == 2">
                            <p>为进一步明确“基于教学改革、融合信息技术的新型教与学模式”实验区工作重点，提升项目人员信息化领导力、学科教学与信息技术融合的教研指导能力，9月7日，
                                兴安盟教育局召开“基于教学改革、融合信息技术的新型教与学模式”实验项目培训暨工作推进会。盟教育局党组成员、副局长陈凤君，项目工作组、各旗县市教育局、
                                教师发展中心、实验学校校长以及相关同志参加会议。</p>
                            <img src="../assets/detail/01.jpeg" alt="">
                            <p>会上，盟教师发展中心副主任高英对实验区工作进展进行通报；各旗县市教育局相关负责同志进行实验区工作汇报；乌兰浩特市第五中学、第十五中学进行实验校经验分享。</p>
                            <p>苏小平教授作《新型教与学模式的重点关注》讲座。</p>
                            <img src="../assets/detail/02.png" alt="">
                            <img src="../assets/detail/03.jpeg" alt="">
                            <p>陈凤君在总结讲话中强调，教育部“基于教学改革、融合信息技术的新型教与学模式”实验项目是一个重要机遇，我们要通过三级协同推进、定期调度跟进、成果推广共享、多种形式自我提升、
                                完善督导评估体系等方式，探索“互联网+”形态下教学方式的变革，研究智慧课堂构建、信息技术与学科教学深度融合、“双减”背景下作业设计的有效实施途径，
                                努力实现“培育一批能够带动区域教师信息素养和教学能力提升的教师，打造一批教学示范标杆校”的目标，探索并形成可示范推广的融合信息技术的新型教与学的模式和机制，形成教育发展新生态。
                            </p>
                        </template>
                    </div>
                </div>
            </div>
            <div class="news_detail_right">
                <div class="subtitle flex-align-between">
                    <h2 class="text text-first flex-align">最新推荐</h2>
                </div>
                <div class="timeline-list">
                    <el-timeline>
                        <el-timeline-item v-for="(activity, index) in activities" :key="index" type="primary"
                            color="#BEE3FF" size="large" :timestamp="activity.detailCreateTime" class="timeline-item"
                            hide-timestamp>
                            <div @click="toPage(activity)" class="timeline-item-inner">
                                <p class="f12 timeline-time">{{activity.content.time}}</p>
                                <p class="f12 timeline-introduce">{{activity.content.text}}</p>
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
        <!-- <scorllTop :share="false"></scorllTop> -->
    </div>
</template>

<script>
    import breadcrumb from './components/common/breadcrumb.vue';
    export default {
        components: {
            breadcrumb
        },
        data() {
            return {
                crumbPath: '',
                crumbName: '',
                crumbTopicListId: 1,
                article: {},
                prev: {},
                next: {},
                hasHover: false,
                activities: [{
                        content: {
                            time: '2020.06.03',
                            text: '首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
                        },
                    }, {
                        content: {
                            time: '2020.06.03',
                            text: '首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
                        },
                        color: '#BEE3FF'
                    }, {
                        content: {
                            time: '2020.06.03',
                            text: '首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
                        },
                        color: '#BEE3FF'
                    }, {
                        content: {
                            time: '2020.06.03',
                            text: '首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
                        },
                        color: '#BEE3FF'
                    },
                    {
                        content: {
                            time: '2020.06.03',
                            text: '首都教育远程互助工程“北京-银川”“互联网+教育” 首都师京-银川”“互联京-银川”“互联京-银川”“互联范大学“双优云桥',
                        },
                        color: '#BEE3FF'
                    }
                ]
            }
        },
        watch: {
            // $route(to, from) {
            //   document.body.scrollTop = 0
            //   document.documentElement.scrollTop = 0
            // }
        },
        computed: {

        },
        methods: {
            async getArticle() {
                let params = {
                    id: this.$route.params.id
                }
                let resData = await Api.Home.GetNewsDetail(params);
                this.article = resData.data;
                this.$store.commit('breadPageNameChange', this.article.title)
                // console.log(resData);
            },

            async getRecommend() {
                let resData = await Api.Home.GetNewsRecommend()
                // console.log(resData);
                this.activities = resData.data;
            },

            async getNearInfo() {
                let params = {
                    id: this.$route.params.id
                }
                let resData = await Api.Home.GetNear(params);
                this.prev = resData.data[0];
                this.next = resData.data[1];
                //console.log(resData);
            },
            toPage(item) {
                // console.log(item)
                // if (item.id !== undefined) {
                //     Common.goPage(`/home/news/detail/${item.id}?type=${this.$route.query.type}`, this)
                //     this.init();
                // }
            },
            init() {
                scroll(0, 0)
                this.getArticle();
                this.getRecommend();
                this.getNearInfo();
            },
        },
        mounted() {
            // this.init();
        },
    }
</script>

<style lang="less" scoped>
    @basisColor: #508EF9;
    @bgColor: #FAFAFA;
    @white: #fff;

    .news-detail {
        background-color: #FAFAFA !important;

        .news-detail-wrapper {
            margin-bottom: 150px;
        }

        .news_detail_left {
            box-sizing: border-box;
            padding: 28px 33px;
            width: 677px;
            border-radius: 8px;

            background-color: #fff;


            .title-box {
                border-bottom: 1px solid #E4E4E4;

                h3 {
                    margin-bottom: 8px;
                    color: #508EF9;
                    font-weight: bold;
                }

                p {
                    color: #999;
                    margin-bottom: 10px;
                }

                .eye {
                    display: inline-flex;
                    align-items: center;

                    margin-bottom: 7px;
                    margin-left: 28px;
                }

                .eye::before {
                    content: ' ';
                    display: inline-block;

                    margin-right: 4px;
                    width: 20px;
                    height: 20px;

                    background-image: url("../assets/common/eye.png");
                    background-size: 20px 20px;
                    background-repeat: no-repeat;
                }

                .source span {
                    margin-right: 10px;
                }
            }

            .content {
                padding: 30px 0 50px;
                border-bottom: 1px solid #E4E4E4;
                line-height: 25px;

                /deep/ img {
                    max-width: 100%;
                }

                p,
                span {
                    word-break: break-all;
                }

                p {
                    text-indent: 2em;
                    margin-bottom: 20px;
                }
            }


            .pagination {
                p {
                    padding: 23px 0 0;
                    max-width: 45%;
                    cursor: pointer;

                    &:hover {
                        text-decoration: underline;
                        color: #508EF9;
                    }
                }

                p.not-hover:hover {
                    text-decoration: none;
                    color: #333;
                    cursor: default;
                }
            }




        }

        .news_detail_right {
            width: 300px;
            flex-shrink: 0;
            border-radius: 8px;
            height: fit-content;
            background-color: #fff;
            overflow: hidden;

            .subtitle {
                padding: 0 22px;
                border-bottom: 1px dashed #508EF9;
                height: 49px;
                font-size: 13px;

                color: #508EF9;

                .text::before {
                    content: ' ';
                    display: inline-block;

                    margin-right: 11px;
                    width: 16px;
                    height: 20px;
                }

                .text-first::before {
                    background-image: url("~@/assets/common/recommed.png");
                    background-repeat: no-repeat;
                }
            }

            /deep/ .timeline-list {
                padding: 28px 20px 0;

                .timeline-item {
                    cursor: pointer;
                    line-height: 20px;

                    .el-timeline-item__tail {
                        border-left: 1px solid rgba(80, 142, 249, .3);
                    }

                    &:first-child .el-timeline-item__tail {
                        height: 130%;
                        top: -10px;
                    }

                    &:nth-last-child(2) .el-timeline-item__tail {
                        height: 1000%;
                    }

                    .timeline-time {
                        margin-bottom: 5px;
                    }

                    .timeline-introduce {
                        line-height: 22px;
                    }
                }

                .timeline-item::before {
                    content: ' ';
                    display: inline-block;
                    position: absolute;
                    top: 3px;
                    left: 1px;
                    z-index: 999;

                    border-radius: 50%;
                    width: 8px;
                    height: 8px;

                    background-color: #508EF9;
                }

                .timeline-item-inner:hover {
                    color: #508EF9;
                }
            }
        }

        @media screen and (min-width:1250px) {
            .news_detail_left {
                padding: 36px 40px;
                width: 820px;
            }

            .news_detail_right {
                width: 364px;

                .subtitle {
                    padding: 0 22px;
                    height: 60px;
                    font-size: 16px;
                }
            }
        }

    }
</style>